<template>
  <main>
    <!-- Campaign general info section -->
    <CampaignInfoSection :parCampaignId="this.$route.params.id" :parPageRights="pageRights" />

    <!-- Discount info section -->
    <section class="whiteBox">
      <div class="content">
        <div class="row spaceBetween" v-if="pageRights.manageDiscount">
          <p class="accentuate">{{$t('campaigns.associatedDiscountsSection')}}</p>
          <button
            class="outline"
            @click="addDiscountToGroupOfDiscount(groupsOfDiscounts[0])"
          >{{$t('button.associateDiscount')}}</button>
        </div>
        <div class="row">
          <table>
            <thead>
              <tr>
                <th class="accentuate">{{$t('products.productName')}}</th>
                <th class="accentuate">{{$t('salesChannel.salesChannel')}}</th>
                <th class="accentuate">{{$t('campaigns.discount')}}</th>
                <th class="accentuate">{{$t('coupons.couponCode')}}</th>
                <th class="accentuate">{{$t('campaigns.use')}}</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="discount in this.discountsList" :key="discount.id">
                <td>{{discount['product-name']}}</td>
                <td>{{discount['sales-channel-name']}}</td>
                <td v-if="discount['discount-value']==0" nowrap>
                  <p class="chipValue void">{{$t('discountValue.noDiscount')}}</p>
                </td>
                <td
                  v-else-if="discount['discount-type']==0 && discount['discount-value']==100"
                  nowrap
                >
                  <p class="chipValue red">{{$t('discountValue.free')}}</p>
                </td>
                <td v-else nowrap>
                  <p
                    class="chipValue lightorange"
                    v-if="discount['discount-type'] === 1"
                  >-{{(discount['discount-value']/100).toFixed(2)}}{{convertCurrencyToSymbol(discount['discount-currency'])}}</p>
                  <p
                    class="chipValue orange"
                    v-if="discount['discount-type'] === 0"
                  >-{{discount['discount-value']}}%</p>
                </td>
                <td>
                  {{campaign['global-code']}} &nbsp; &nbsp;
                  <button
                    @click="copyToClipBoard(campaign['global-code'])"
                  >{{$t('button.copy')}}</button>
                </td>
                <td>
                  {{discount['number-of-used-coupons']}}
                  &nbsp; &nbsp;
                  <button>{{$t('button.details')}}</button>
                </td>
                <td>
                  <span
                    class="comments"
                    v-if="discount['archived']"
                  >{{$t('discounts.discountArchived')}}&nbsp;</span>
                  <span
                    class="comments"
                    v-if="discount['product-archived']"
                  >{{$t('discounts.productArchived')}}&nbsp;</span>
                  <span
                    class="comments"
                    v-if="discount['sales-channel-archived']||discount['sales-channel-api-key-status']!=0"
                  >{{$t('discounts.channelArchived')+ ' ('+discount['sales-channel-name']+')'}}&nbsp;</span>
                </td>
                <td>
                  <span
                    class="chip grey"
                    v-if="discount['sales-channel-archived']||discount['product-archived']||discount['archived']||discount['sales-channel-api-key-status']!=0"
                  >{{$t('discounts.isArchived')}}</span>
                </td>
                <td class="bubbleParent" v-if="pageRights.manageDiscount">
                  <button
                    ref="bubble"
                    class="outline"
                    @click="bubbleClick('discount'+discount.id);campaingSubMenu=false"
                  >
                    <img
                      ref="bubble"
                      class="pastille"
                      src="@/assets/images/pastille.png"
                      alt="pastille"
                    />
                  </button>
                  <div class="bubble" v-if="bubbleAction('discount'+discount.id)">
                    <a @click="modifyDiscount(discount)">{{$t('discounts.modify')}}</a>
                    <a
                      v-if="!discount['archived']"
                      class="redText"
                      @click="archiveDiscount(discount)"
                    >{{$t('discounts.archive')}}</a>
                    <a
                      v-if="discount['archived']"
                      @click="archiveDiscount(discount)"
                    >{{$t('discounts.activate')}}</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <!-- Coupon uses Section -->
    <CouponHistorySection :parCampaignId="this.$route.params.id"></CouponHistorySection>

    <!-- Users Section -->
    <UserSection
      :parUserPageRights="this.pageRights.manageCampaignUser"
      :parCampaignId="this.$route.params.id"
    ></UserSection>
    <ConfirmationBox
      v-if="show.confirm"
      :parData="confirmationData"
      @continueprocess="continueProcess"
      @close="show.confirm=false"
    ></ConfirmationBox>
    <!-- Log Section -->
    <section class="whiteBox" v-if="pageRights.logCampaign">
      <div class="content">
        <p class="accentuate">{{$t('campaigns.logsSection')}}</p>
        <br />
        <table>
          <thead>
            <tr>
              <th>{{$t('dateManagement.date')}}</th>
              <th>{{$t('campaigns.logDetails')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- over the page displays 
    ------------------------------->

    <!-- managne/modifiy discount -->
    <ManageDiscount
      v-if="displayDiscountManagement"
      :parMethod="this.discountMethod"
      :parDiscount="this.curDiscount"
      :parGroupOfDiscounts="this.groupOfDiscounts"
      @close="displayDiscountManagement = false"
      @operationondiscountdone="manageDiscountWithParams"
    ></ManageDiscount>
  </main>
</template>

<script>
import moment from "moment";
import Campaigns from "@/services/Campaigns";
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
import Discounts from "@/services/Discounts";
import bubble from "@/mixins/bubble";
import ManageDiscount from "@/components/discounts/ManageDiscount";
import CampaignInfoSection from "@/components/campaigns/manageCampaign/CampaignInfoSection.vue";
import getCampaignDetails from "@/mixins/getCampaignDetails";
import generalMethods from "@/mixins/generalMethods";
import UserSection from "@/components/campaigns/campaignDetails/UsersSection";
import CouponHistorySection from "@/components/campaigns/campaignDetails/CouponHistorySection";
import ConfirmationBox from "@/mixins/ConfirmationBox";
export default {
  mixins: [bubble, getCampaignDetails, generalMethods],
  components: {
    ManageDiscount,
    UserSection,
    CouponHistorySection,
    ConfirmationBox,
    CampaignInfoSection
  },
  data() {
    return {};
  },
  mounted() {
    this.getGroupsOfDiscounts(this.$route.params.id);
    this.getCampaignInfoById(this.$route.params.id);
  },
  created() {
    document.addEventListener("click", this.manageMenu);
  },
  destroyed() {
    document.removeEventListener("click", this.manageMenu);
  },
  methods: {
    getGroupsOfDiscounts(campaignId) {
      GroupsOfDiscounts.get(campaignId).then(res => {
        if (res.status == 200) {
          this.groupsOfDiscounts = res.data;
        }
      });
    },
    getCampaignInfoById(id) {
      if (id) {
        Campaigns.getById(id).then(res => {
          if (res.data["number-of-used-coupons"] == null)
            res.data["number-of-used-coupons"] = "0";
          else
            res.data["number-of-used-coupons"] = res.data[
              "number-of-used-coupons"
            ].toLocaleString("fr");

          if (res.data["max-number-of-coupons"] == null)
            res.data["max-number-of-coupons"] = "0";
          else
            res.data["max-number-of-coupons"] = res.data[
              "max-number-of-coupons"
            ].toLocaleString("fr");
          this.campaign = res.data;

          this.getDiscountsByCampaignId(id);
          this.checkUserRights();
        });
      }
    },
    exportCampaignInfoCSV() {
      //info sur la campagne
      var csv = "Campaign name, Start date, End date, Number of coupons\n";
      csv += this.campaign.name;
      csv += ",";
      csv += moment(this.campaign["start-date"]).format(`DD/MM/YYYY - HH:mm`);
      csv += ",";
      csv += moment(this.campaign["expiration-date"]).format(
        `DD/MM/YYYY - HH:mm`
      );
      csv += ",";
      csv += this.campaign["max-number-of-coupons"];
      csv += ",";
      csv += "\n";
      csv +=
        "Product name, Sales Channel, Merchant Name, Number of used coupons,  Total applied discount\n";
      //info sur les discounts
      var totalCoupon = 0;
      var totalDiscount = 0;
      //console.log(this.discountsList); // TO_DO remove
      this.discountsList.forEach(row => {
        csv += row["product-name"];
        csv += ",";
        csv += row["sales-channel-name"];
        csv += ",";
        csv += row["sales-channel-merchant-name"];
        csv += ",";
        csv += row["number-of-used-coupons"];
        csv += ",";
        csv += row["total-sum-of-discounts"] / 100;
        csv += ",";
        csv += row["discount-currency"];
        csv += "\n";
        totalDiscount += row["total-sum-of-discounts"] / 100;
        totalCoupon += row["number-of-used-coupons"];
      });
      csv += "Grand Total, , ," + totalCoupon + "," + totalDiscount + "\n";
      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
      hiddenElement.target = "_blank";
      hiddenElement.download =
        "campaign-" + this.campaign.name + "-summary.csv";
      hiddenElement.click();
    },
    getDiscountsByCampaignId(id) {
      Discounts.getByCampaignId(id).then(res => {
        this.discountsList = res.data;
      });
    }
  }
};
</script>
<style scoped>
</style>